import {
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { catchError, of, tap } from 'rxjs';

import { ConnectorService } from 'src/app/connector-manager/services/connector.service';

@Component({
  selector: 'app-pane-info',
  templateUrl: './pane-info.component.html',
  styleUrls: ['./pane-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PaneInfoComponent implements OnInit {
  @Input() objectId!: string;
  @Input() objectTypeId!: number;
  @Input() objectClassId!: number;

  html: SafeHtml | null = null;
  loading = false;

  private destroyRef = inject(DestroyRef);
  private connectorService = inject(ConnectorService);
  private sanitizer = inject(DomSanitizer);

  ngOnInit(): void {
    if (!this.objectId || !this.objectTypeId || !this.objectClassId) return;

    this.loading = true;
    this.connectorService
      .fetchPaneInfo({
        id: this.objectId,
        object_type_id: this.objectTypeId,
        object_class_id: this.objectClassId,
      })
      .pipe(
        tap((result) => {
          this.html = result?.html
            ? this.sanitizer.bypassSecurityTrustHtml(result.html)
            : null;
          this.loading = false;
        }),
        catchError(() => {
          this.loading = false;
          return of(null);
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
